import { doc, onSnapshot } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { janelaDoResumo, periodoAnterior, type ResumoDoGrupo, type ResumoPessoal } from "@nhomi/core";
import { db, functions } from "./ambiente";

/* Resumo do mês e retrospectiva do ano — só leitura; quem monta é o
   servidor (`functions/src/resumos.ts`). O pessoal, a regra só deixa a
   própria pessoa ler. */

export type Resumo = ResumoDoGrupo & { nomeDoDesafio?: string };

export function watchResumo(cid: string, periodo: string, cb: (r: Resumo | null) => void): () => void {
  return onSnapshot(doc(db, "challenges", cid, "resumos", periodo),
    (s) => cb(s.exists() ? (s.data() as Resumo) : null), () => cb(null));
}

export function watchResumoPessoal(
  cid: string, periodo: string, uid: string, cb: (r: ResumoPessoal | null) => void,
): () => void {
  return onSnapshot(doc(db, "challenges", cid, "resumos", periodo, "pessoas", uid),
    (s) => cb(s.exists() ? (s.data() as ResumoPessoal) : null), () => cb(null));
}

/** Monta (se ainda não existe) o resumo de um período que já fechou. */
export async function pedirResumo(cid: string, periodo: string): Promise<void> {
  await httpsCallable<{ cid: string; periodo: string }, { ok: boolean }>(functions, "nhomiPedirResumo")({ cid, periodo });
}

/**
 * Os resumos que já podem existir: os meses fechados desde o começo do
 * desafio (do mais novo para o mais velho, até 12) e os anos fechados.
 */
export function periodosFechados(startDay: string, hoje: string): string[] {
  const ano = String(Number(hoje.slice(0, 4)) - 1);
  const lista: string[] = [];
  let p = periodoAnterior(hoje.slice(0, 7));
  for (let i = 0; i < 12; i++) {
    const j = janelaDoResumo(p)!;
    if (startDay && j.ate < startDay) break;
    // A retrospectiva do ano entra logo antes do dezembro dela.
    if (p === `${ano}-12`) lista.push(ano);
    lista.push(p);
    p = periodoAnterior(p);
  }
  return lista;
}
